import { platform } from "~/platform/socket";
import { useTranslation } from "~/primitives/translator";
import { PostTopic } from "../types/post";
import gql from "graphql-tag";

interface FetchPostTopicsResult {
	postTopics: PostTopic[];
}

export async function fetchPostTopics(): Promise<PostTopic[]> {
	const query = gql`
		query {
			postTopics {
				id
				name
			}
		}
	`;

	const result = await platform.query<FetchPostTopicsResult>(query);
	const translator = useTranslation;

	return await Promise.all(
		result.postTopics.map<Promise<PostTopic>>(async (topic) => ({
			...topic,
			name: await translator(topic.name),
		})),
	);
}